import { VraagboomAntwoord, VraagboomMultiResultaat } from '@models/vragenboom';
import { VariableContent, Antwoord, Vraag, VraagMail, IndienenVragenMailRequest } from '@models/claims';
import { TekstMapper } from './tekst-mapper';

export class ContactgegevensMapper {
  public static mapResultaten(vraagboomAntwoord: VraagboomAntwoord<VraagboomMultiResultaat>, variabeleContent: VariableContent[], vragen: Vraag[]) {
    TekstMapper.mapResultatenMulti(vraagboomAntwoord, variabeleContent, vragen);
  }

  public static mapResultatenMail(vraagboomAntwoord: VraagboomAntwoord<VraagboomMultiResultaat>, vragen: VraagMail[], request: IndienenVragenMailRequest) {
    TekstMapper.mapResultatenMultiMail(vraagboomAntwoord, vragen);
    if (vraagboomAntwoord == null) {
      return;
    }

    vraagboomAntwoord.antwoorden.forEach((antw: Antwoord) => {
      if (antw.variabeleWaarde.toUpperCase().indexOf('NAAM') > -1) {
        request.naam = antw.waarde;
      }
      if (antw.variabeleWaarde.toUpperCase().indexOf('EMAIL') > -1) {
        request.email = antw.waarde;
      }
    });
  }
}
